module.exports = __webpack_public_path__ + "static/img/24.69d14e1b.png";